import { useEffect } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setViewWidth } from '../../modules/view';
import MyBoxPage from '../MyBoxPage/MyBoxPage';
import './App.css';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import { GlobalNav } from '@fff-web/fff-global-nav';
import env from '../../utils/env';

const App = ({ setViewWidthAction, userData }) => {
  const { chatbotAppliedLab: showChatbot } = useFlags();

  useEffect(
    () => window.addEventListener('resize', () => setViewWidthAction(window.innerWidth)),
    [setViewWidthAction],
  );

  return (
    <div>
      <GlobalNav />
      <main className="my-box-page">
        <Routes>
          <Route path="*" element={<MyBoxPage userData={userData} />} />
        </Routes>
      </main>
      <GlobalFooter
        chatbotConfig={{ agentId: env.appliedLabsChatbotAgentId, hideWidget: !showChatbot }}
      />
    </div>
  );
};

const mS = (state) => ({
  isMobile: state.view.isMobile,
});

const mD = (dispatch) =>
  bindActionCreators(
    {
      setViewWidthAction: setViewWidth,
    },
    dispatch,
  );

App.propTypes = {
  setViewWidthAction: func.isRequired,
  userData: object.isRequired,
};

export default connect(mS, mD)(App);
